/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import MainLayout from "layouts/MainLayout";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchCourtLevel, fetchCourtType } from "services/basedataServices";
import { editCaseCreation, editOpeningCaseFile } from "services/caseServices";
import {
  CaseCreation,
  CourtLevelBaseData,
  CourtTypeBaseData,
  OpeniningCaseFile,
  Roles,
} from "types";
import { errorHandlerOnForm, hasRole } from "utils/helper";

const defaultValue: OpeniningCaseFile = {
  id: 0,
  defendants: [],
  status: "Pending",
  assign_prosecutor: "",
  userid_assign_prosecutor: "",
  prosecutor_registration_number: "",
  incident_registration_no: "",
  crime_refernce_number: "",
  court_type: "",
  court_level: "",
  court_registration_number: "",
  court_hearing_place: "",
  zone: "",
  city: "",
  sub_city: "",
  woreda: "",
  first_court_hearing_date: new Date(),
  reassign_prosecutor: "",
  reassign_prosecutor_userid: "",
};
const UpdateCourtDetail: React.FC = () => {
  const { state } = useLocation();
  const caseData: CaseCreation | null = state?.caseData || null;
  const navigate = useNavigate();
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();
  // const [selectedDefendant, setSelectedDefendant] = useState<Suspect>();

  const [formState, setFormState] = useState<OpeniningCaseFile>(defaultValue);

  const [baseData, setBaseData] = useState<{
    courtType: CourtTypeBaseData[];
    courtLevel: CourtLevelBaseData[];
  }>({
    courtType: [],
    courtLevel: [],
  });

  useEffect(() => {
    if (caseData?.opening_case_files) {
      console.log(caseData?.opening_case_files[0]);
      const data = caseData?.opening_case_files[0];
      setFormState({
        ...data,
        crime_refernce_number: data?.crime_refernce_number,
        incident_registration_no: data?.incident_registration_no,
        prosecutor_registration_number: data?.prosecutor_registration_number,
        first_court_hearing_date: new Date(data?.first_court_hearing_date),
        court_registration_number: data?.court_registration_number,
        court_type: data?.court_type,
        court_level: data?.court_level,
        court_hearing_place: data?.court_hearing_place,
        zone: data?.zone,
        city: data?.city,
        sub_city: data?.sub_city,
        woreda: data?.woreda,
      });
    }
  }, [caseData]);

  useEffect(() => {
    fetchCourtType().then((data) =>
      setBaseData((prev) => ({ ...prev, courtType: data }))
    );
    fetchCourtLevel().then((data) =>
      setBaseData((prev) => ({ ...prev, courtLevel: data }))
    );
  }, []);

  // useEffect(() => {
  //   if (caseData) {
  //     setFormState({
  //       ...formState,

  //       case: caseData?.id,
  //       // defendant_case_detail: caseData?.id ?? undefined,
  //       crime_refernce_number: caseData?.crime_refernce_number || "",
  //       incident_registration_no: caseData?.incident_registration_no || "",
  //       prosecutor_registration_number:
  //         caseData?.prosecutor_registration_number || "",
  //     });
  //   }
  // }, [caseData]);

  useEffect(() => {
    if (loginData) {
      setFormState((prevState) => ({
        ...prevState,
        receiving_prosecutor: hasRole(loginData?.roles, [Roles.prosecutor])
          ? loginData?.user_id
          : null,
        receiving_police: hasRole(loginData?.roles, [Roles.member])
          ? loginData?.user_id
          : null,
      }));
    }
  }, [loginData]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formState.crime_refernce_number)
      return "Crime Reference Number is Required.";
    else if (!formState.incident_registration_no)
      return "Incident Registration Number is Required.";
    else if (!formState.prosecutor_registration_number)
      return "Prosecutor Registration Number is Required.";
    else if (!formState.court_hearing_place)
      return "Court Hearing Place is Required.";

    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }
    const formData: OpeniningCaseFile = {
      ...formState,
      status: "forwarded_to_coordinator",
      // defendants: selectedDefendant ? [selectedDefendant?.uu_id] : [],
      is_venue_changed: state?.is_venue_changed ? true : false,
    };
    editOpeningCaseFile(formData)
      .then(() => {
        if (caseData) {
          editCaseCreation({
            id: caseData?.id,
            status: "Respond_Back_cordinator",
            // Adding court details moves the case into the court-hearing stage.
            status_filter: "on_court_hearing",
            // The court-update request is resolved once the registrar updates
            // the court detail — clear the flag so the court tab shows again.
            is_case_updated_by_court: false,
          });
        }

        showTooltip("Successfully Submitted!", "success");
        navigate(-1);
      })
      .catch((err) => {
        showTooltip(errorHandlerOnForm(err?.response?.data), "error");
      });
  };

  return (
    <MainLayout>
      <div className="incidentRegistration max-w-screen-lg">
        <div className="incident-title">
          <span className="text-2xl font-semibold text-gray-700">
            ⚖ Update Court
          </span>
        </div>
        <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
          <form onSubmit={handleSubmit}>
            <div className="bg-white shadow-md rounded-lg p-6 mt-4 ">
              <div>
                <div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Crime Registration Number
                      </label>
                      <input
                        type="text"
                        placeholder="#123456"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="crime_refernce_number"
                        value={formState?.crime_refernce_number ?? ""}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Incident Registration Number
                      </label>
                      <input
                        type="text"
                        placeholder="#123456"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="incident_registration_no"
                        value={formState?.incident_registration_no ?? ""}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Prosecutor Registration Number
                      </label>
                      <input
                        type="text"
                        placeholder="#123456"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="prosecutor_registration_number"
                        value={formState?.prosecutor_registration_number ?? ""}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        First Court Hearing Date
                      </label>
                      <input
                        type="date"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="first_court_hearing_date"
                        value={
                          formState?.first_court_hearing_date
                            ? new Date(formState.first_court_hearing_date)
                                .toISOString()
                                .split("T")[0]
                            : ""
                        }
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Court Registration Number
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="court_registration_number"
                        value={formState?.court_registration_number ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Court Type
                      </label>
                      <select
                        className="border capitalize border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                        name="court_type"
                        value={formState?.court_type ?? ""}
                        onChange={handleChange}
                      >
                        <option value={""}>Select Court Type</option>
                        {baseData.courtType?.map((data, index) => (
                          <option
                            key={index}
                            value={data.type}
                            className="capitalize"
                          >
                            {data.type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Court Level
                      </label>

                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="court_level"
                        value={formState?.court_level ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Court Hearing Place
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="court_hearing_place"
                        value={formState?.court_hearing_place ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Zone
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="zone"
                        value={formState?.zone ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        City
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="city"
                        value={formState?.city ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Sub City
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="sub_city"
                        value={formState?.sub_city ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Woreda
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="woreda"
                        value={formState?.woreda ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-row mt-4 gap-3">
              {!caseData && (
                <input
                  type="reset"
                  className="border border-[#212121] px-[76px] py-3 text-[#747474] font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#D4D4D4]"
                  value={"Cancel"}
                />
              )}
              <input
                type="submit"
                className="border border-[#212121] bg-[#212121] px-[76px] py-3 text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]"
                value={caseData ? "Save" : "Finish"}
              />
            </div>
          </form>
        </div>
      </div>
    </MainLayout>
  );
};

export default UpdateCourtDetail;
